import { Component, h, Prop, State } from '@stencil/core';
import { Dimensions } from '../../utils/types';
import { t } from '../../../../redux/utils';

@Component({
  tag: 'rtr-article-details-gallery',
  styleUrl: 'style.sass',
  shadow: false,
})
export class RtrArticleDetailsGallery {
  @Prop() name: string;
  @Prop() images: string[];
  @Prop() onShowFullGallery: (show: boolean) => void;
  @Prop() static: boolean = false;

  @State() c1Dims: Dimensions;
  @State() c2Dims: Dimensions;
  @State() c3Dims: Dimensions;
  @State() c4Dims: Dimensions;

  private c1: HTMLDivElement;
  private c2: HTMLDivElement;
  private c3: HTMLDivElement;
  private c4: HTMLDivElement;

  componentDidLoad() {
    if (this.c1) {
      this.c1Dims = { width: this.c1.clientWidth, height: this.c1.clientHeight };
    }
    if (this.c2) {
      this.c2Dims = { width: this.c2.clientWidth, height: this.c2.clientHeight };
    }
    if (this.c3) {
      this.c3Dims = { width: this.c3.clientWidth, height: this.c3.clientHeight };
    }
    if (this.c4) {
      this.c4Dims = { width: this.c4.clientWidth, height: this.c4.clientHeight };
    }
  }

  get firstImageContainerLoaded() {
    return this.c1;
  }

  get secondImageContainerLoaded() {
    return this.c2;
  }

  get fourthImageContainerLoaded() {
    return this.c4;
  }

  get showSecondImage() {
    return this.images?.[1];
  }

  get showThirdImage() {
    return this.images?.[2];
  }

  get showFourthImage() {
    return this.images?.[4];
  }

  get showMoreButton() {
    return !this.static && this.images.length > 4;
  }

  showFullGallery = () => {
    if (!this.static) {
      this.onShowFullGallery(true);
    }
  };

  get showAllText() {
    return t('details.showAll');
  }

  get imageClass() {
    if (!this.static) {
      return 'ADGImage';
    }
  }

  render() {
    if (!this.images.length) {
      return null;
    }

    return (
      <div class="ADGWrapper">
        <div class="ADGFirstContainer AGDField">
          <div class="ADGFirstImage AGDField" ref={el => (this.c1 = el as HTMLDivElement)}>
            {this.firstImageContainerLoaded && (
              <rentware-image src={this.images[0]} alt={this.name} vw={this.c1Dims.width} forceAspectRatio={true} onClick={this.showFullGallery} class={this.imageClass} />
            )}
          </div>

          {this.showSecondImage && (
            <div class="ADGSecondContainer AGDField">
              <div class="ADGSecondImage AGDField" ref={el => (this.c2 = el as HTMLDivElement)}>
                {this.secondImageContainerLoaded && (
                  <rentware-image src={this.images[1]} alt={this.name} vw={this.c2Dims.width} forceAspectRatio={true} onClick={this.showFullGallery} class={this.imageClass} />
                )}
              </div>

              {this.showThirdImage && (
                <div class="ADGThirdContainer AGDField">
                  <div class="ADGThirdImage AGDField" ref={el => (this.c3 = el as HTMLDivElement)}>
                    {this.secondImageContainerLoaded && (
                      <rentware-image src={this.images[2]} alt={this.name} vw={this.c3Dims.width} forceAspectRatio={true} onClick={this.showFullGallery} class={this.imageClass} />
                    )}
                  </div>

                  {this.showFourthImage && (
                    <div class="ADGFourthImage AGDField" ref={el => (this.c4 = el as HTMLDivElement)}>
                      {this.fourthImageContainerLoaded && (
                        <rentware-image
                          src={this.images[3]}
                          alt={this.name}
                          vw={this.c4Dims.width}
                          forceAspectRatio={true}
                          onClick={this.showFullGallery}
                          class={this.imageClass}
                        />
                      )}
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
        </div>
        {this.showMoreButton && (
          <div class="ADGShowMore" onClick={this.showFullGallery}>
            {this.showAllText}
          </div>
        )}
      </div>
    );
  }
}
